import { showGlobalModal } from "../actions/globalModalActions";

export const globalModalMiddleware = ({ dispatch }) => next => action => {
  if (action.meta && action.meta.globalModal) {
    dispatch(showGlobalModal(action.meta.globalModal));
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/globalModalMiddleware.js